import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './UserContext'; // Import the UserProvider
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import NotificationsPage from './components/NotificationsPage'; // Import the NotificationsPage component
import UserProfile from './components/UserProfile';
import MainPage from './components/MainPage';
// import MobileCardMaker from './MobileCardMaker';
import Contest from './components/Contest';
import ContestList from './components/ContestList';
import ReportsMod from './components/ReportsMod';
import ModerationLog from './components/ModerationLog';
// import SetTest from './components/SetTest';
// import CardCreator from './components/CardCreator'; // Adjust path
// import templateData from './minionTemplate.json'; // Adjust path

import NotFound from './components/NotFound';
import UserCardOrganizer from './components/UserCardOrganizer';
import SearchResultsPage from './components/SearchResultsPage';
// import SetDisplay from './components/SetDisplay';

const router = createBrowserRouter([
  // {
  //   path: "creator",
  //   element: <MobileCardMaker />,
  // },
  // {
  //   path: "testset",
  //   element: <SetTest />,
  // },
  // {
  //   path: "cardcreator",
  //   element: <CardCreator templateJson={templateData} />,
  // },
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <MainPage />,
      },
      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "search-results",
        element: <SearchResultsPage />,
      },
      {
        path: "mycards",
        element: <UserCardOrganizer />,
      },
      {
        path: "user/:userId",
        element: <UserProfile />,
        children: [
          {
            path: ":tab",
            element: <UserProfile />,
          },
        ]
      },
      {
        path: "contests/list",
        element: <ContestList />,
      },
      {
        path: "contests/:id",
        element: <Contest />,
      },
      {
        path: "reports",
        element: <ReportsMod />,
      },
      {
        path: "moderation",
        element: <ModerationLog />,
      },
    ],
  },
  // {
  //   path: "sets/:setId",
  //   element: <SetDisplay />,
  // },
  {
    path: "*",
    element: <NotFound />,
  },
], {
  basename: '/gallery/' // Set the basename to your subdirectory
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <UserProvider>
      <RouterProvider router={router} />
	    </UserProvider>
  </React.StrictMode>
);
